import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

import { AreaDetailsState } from './reducer';

export const getItems = (state: RootState) => state.areaDetails.items;
export const getErrors = (state: RootState) => state.areaDetails.errors;

export const getAreaDetails = (state: RootState) => state.areaDetails;

export const getAreaName = (state: RootState) => state.areaDetails.items.areaName;
export const getParentAreaName = (state: RootState) => state.areaDetails.items.parentAreaName;
export const getHeroImage = (state: RootState) => [{ url: state.areaDetails.items.heroImage }];
export const getRecommendedProviders = (state: RootState) =>
  state.areaDetails.items.recommendedProviders;
export const getRecommendedAreas = (state: RootState) => state.areaDetails.items.recommendedAreas;
export const getAreas = (state: RootState) => state.areaDetails.areaInfoItems.areas;

export const getChildAreas = (state: RootState) => state.areaDetails.items.childAreas;
export const getSiblingAreas = (state: RootState) => state.areaDetails.items.siblingAreas;

export const getIsFetching = createSelector(
  getAreaDetails,
  (state: AreaDetailsState) => state.isFetching,
);
